import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

export const createUser = createAsyncThunk(
    'createUserForm/createUser',
    async ({newUser, token}) => {
        const requestBody = JSON.stringify(newUser);
        console.log(newUser);
        const response = await fetch(`${process.env.REACT_APP_BASE_URL}/admin/users/create`,
            {
                method: 'POST',
                headers: {
                    "Content-Type": "application/json",
                    "Authorization": `Bearer ${token}`
                },
                body: requestBody
            }
        )
        .then(response => response.text())
        .then(text => text);
        return response;
    }
)

export const createUserFormSlice = createSlice({
    name: 'createUserForm',
    initialState: {
        userId: '',
        name: '',
        userRole: 'USER',
        branch: '',
        active: false,
        confirming: false,
        creatingNewUser: false,
        failedToCreateNewUser: false,
        status: ''
    },
    reducers: {
        changeNewUserId: (state, action) => {
            return {
                ...state,
                userId: action.payload,
                status: ''
            }
        },
        changeNewUserName: (state, action) => {
            return {
                ...state,
                name: action.payload,
                status: ''
            }
        },
        changeNewUserRole: (state, action) => {
            return {
                ...state,
                userRole: action.payload,
                status: ''
            }
        },
        changeNewUserBranch: (state, action) => {
            return {
                ...state,
                branch: action.payload,
                status: ''
            }
        },
        toggleCreateUserForm: (state) => {
            return {
                ...state,
                active: !state.active,
                status: ''
            }
        },
        setCreateUserConfirming: (state, action) => {
            return {
                ...state,
                confirming: action.payload
            }
        },
        clearCreateUserForm: (state) => {
            return {
                ...state,
                userId: '',
                name: '',
                userRole: 'User',
                branch: ''
            }
        },
        changeStatus: (state, action) => {
            return {
                ...state,
                status: action.payload
            }
        }
    },
    extraReducers: {
        [createUser.pending]: (state) => {
            return {
                ...state,
                creatingNewUser: true,
                failedToCreateNewUser: false
            }
        },
        [createUser.fulfilled]: (state, action) => {
            return {
                ...state,
                creatingNewUser: false,
                failedToCreateNewUser: false,
                status: action.payload
            }
        },
        [createUser.rejected]: (state) => {
            return {
                ...state,
                creatingNewUser: false,
                failedToCreateNewUser: true
            }
        }
    }
})

export const selectCreateUserFormUserId = (state) => state.createUserForm.userId;
export const selectCreateUserFormName = (state) => state.createUserForm.name;
export const selectCreateUserFormUserRole = (state) => state.createUserForm.userRole;
export const selectCreateUserFormBranch = (state) => state.createUserForm.branch;
export const createUserFormIsActive = (state) => state.createUserForm.active;
export const selectConfirmingCreateUser = (state) => state.createUserForm.confirming;
export const createUserStatus = (state) => state.createUserForm.status;
export const creatingNewUser = (state) => state.createUserForm.creatingNewUser;

export const { changeStatus, clearCreateUserForm, toggleCreateUserForm, changeNewUserId, changeNewUserName, changeNewUserRole, changeNewUserBranch, setCreateUserConfirming } = createUserFormSlice.actions;

export default createUserFormSlice.reducer;